import { BuildingsIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { DistrictApartmentsTable } from "@/components/districts/district-apartments-table";
import { Card } from "@/components/ui/card";
import { useDistrict } from "@/contexts/district-context";

export function ApartmentsPage() {
	const { t } = useTranslation();
	const { districtId } = useDistrict();

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-4 p-4 lg:p-6">
			{districtId === null ? (
				<Card className="flex flex-col items-center gap-3 border-dashed bg-muted/30 px-6 py-12 text-center">
					<div className="flex size-12 items-center justify-center rounded-full bg-muted">
						<BuildingsIcon
							weight="duotone"
							className="size-6 text-muted-foreground"
						/>
					</div>
					<p className="text-sm text-muted-foreground">
						{t("apartments.selectDistrictFirst")}
					</p>
				</Card>
			) : (
				<DistrictApartmentsTable districtId={districtId} />
			)}
		</div>
	);
}
